<template>
    <div>
        <!-- <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert> -->
        <!-- <pre>{{ transitions }}</pre> -->
        <div>
            <slot v-bind="{ transitions, startTransition, loading, loadingTransitions }">
                <b-link
                    v-for="trans in transitions"
                    :key="trans.trigger"
                    @click="startTransition(trans)"
                >
                    {{ trans.label }} - {{ trans.description }}
                </b-link>
            </slot>
        </div>

        <b-modal
            v-model="collectDataModal"
            :title="activeTransition.label"
            hide-footer
            centered
            size="md"
        >
            <FormulateForm
                v-model="collectDataValues"
                :schema="collectDataSchema"
                @submit="handleCollectDataSubmit"
                @cancel="handleCollectDataCancel"
            ></FormulateForm>
        </b-modal>

    </div>
</template>

<script>
import { suppliosApi } from '../js/api-service';
import { errorHandling } from '../js/custom-vue-mixins';
import capitalize from 'lodash/capitalize';

// you might not want this to actually display any actions/transitions
// instead, use it mostly renderless
// use it to show the modal for collectData and to pass data to parent with events for what current transitions are?

export default {
    name: 'RfxResponseTransitions',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        responseId: {
            type: String,
            required: true,
        },
        // you can pass in possibleTransitions as a prop
        // OR, if no prop, this will fetch them!
        possibleTransitions: {
            type: Array,
            required: false,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loadingTransitions: false,  // if we are fetching list of transitions (will never happen if they are passed in as a prop)
            loading: false,  // true if we are loading while calling a transition
            usePropTransitions: false,  // gets set to true (in created) if you get them from prop in created()
            transitions: [],  // stash here after api call
            activeTransition: {},  // when we start calling a transition, put it here -- then reset it when done
            collectDataValues: {},  // if you have an activeTransition that requires collect_data, v-model to here? make sure to reset it when done
            collectDataSchema: {},  // set the schema here after you build it -- must do it before you show the modal
            collectDataModal: false,  // v-model that show/hide collect data modal
            canStartTrigger: false,  // a safety mechanism to prevent starting new trigger while things are in transitional state, another transition active, etc. - reset this when we know modal is closed, etc.
        }
    },
    computed: {

    },
    created() {
        this.resetActiveTransition();
        // if you got transitions from prop, use them (and set watcher to watch for changes)
        // otherwise, need to fetch them
        if (this.possibleTransitions) {
            this.transitions = [ ...this.possibleTransitions];
            this.usePropTransitions = true;
        } else {
            this.usePropTransitions = false;
            // call in mounted if this.usePropTransitions is false 
            // this.getTransitions();
        }
    },
    watch: {  // if we use transitions passed in prop, we need to watch for changes
        possibleTransitions: {
            handler: function(newValue) {
                if (!this.usePropTransitions) return;
                this.transitions = [ ...newValue ];
            },
        },
    },
    async mounted() {
        await this.getTransitions();
    },
    methods: {
        // PUBLIC METHODS - if using this like a renderless component
        triggerTransition(triggerName) {
            // can call this from parent -- pass in string name of the trigger like 'go_cancel_invite'
            if (!this.canStartTrigger) return;  // if we can't trigger right now, just return 
            const transObj = this.transitions.find(trans => trans.trigger === triggerName);
            if (transObj) {
                this.startTransition(transObj);
            }
        },
        // PRIVATE METHODS
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async getTransitions() {
            // first, see if you're using transitions from prop -- if so, bail on this
            if (this.usePropTransitions) return;  
            this.loadingTransitions = true;
            try {
                const { data } = await suppliosApi.rfxResponse.get_transitions(this.responseId);
                this.transitions = data;
                this.$emit('transitions-loaded', this.transitions);  // pass these to parent in case you're using like a renderless component
            } catch (err) {
                this.apiErrorHandler(err, 'Error getting transitions');
            }
            this.loadingTransitions = false;
        },
        resetActiveTransition() {
            console.log('HELLO FROM resetActiveTransition');
            this.activeTransition = {};
            this.collectDataValues = {};
            this.collectDataSchema = {};
            this.canStartTrigger = true;  // don't call this method until you know you're ready to start another transition!  like from @hidden of modal
        },
        buildConfirmationElement(confObject) {
            // pass in the entire 'confirmation' object from collect_data
            // this will format it as needed for formulate schema and return new object
            const confDesc = confObject.description ?? '';  // might be undefined, string, or array... set each one as 'p' element in children
            const confParaList = confDesc ? (
                (Array.isArray(confDesc) && confDesc.length) ? confDesc : [ confDesc ]  // if we have something -- make sure its an array
                ) : [];  // if no description at all, just use empty array
            const pComponents = confParaList.map(para => {
                return { component: 'p', children: para };
            });
            return {
                component: 'div',
                class: 'confirmation-message mt-2 mb-4',
                children: [
                    { component: 'h5', children: (confObject.label || '') },
                    ...pComponents,  // one 'p' component for each item in description
                    //{ component: 'p', children: (confObject.description || '') },
                ],
            };
        },
        buildFormSchema(transObj) {
            console.log('HELLO FROM buildFormSchema');
            // pass in full transition object to get collect_data and label for the transition
            // this will return schema to create form using vue-formulate (or some other way)
            const collectData = transObj.collect_data || [];  // should have checked if we had it before calling this anyways
            // build the fields first, then add the submit button and cancel button
            let schema = collectData.map(cd => {
                // HANDLE YOUR 'confirmation' messages first -- to show a confirmation message, with form submit still
                if (cd.name === 'confirmation') {
                    return this.buildConfirmationElement(cd);
                }
                const formField = {
                    type: cd.type || 'text',
                    name: cd.name,  // gotta have this
                    label: cd.label || capitalize(cd.name),
                };
                if (cd.required) {
                    formField.validation = 'required';
                }
                if (cd.options) {
                    formField.options = cd.options;
                }
                if (cd.description) {
                    formField.help = cd.description;
                }
                return formField;
            });
            const buttonDiv = {
                component: 'div',
                class: 'd-flex gap-2',
                children: [
                    {
                        type: 'submit',
                        label: transObj.label,
                    },
                    {
                        type: 'button',
                        label: 'Cancel',
                        '@click': 'cancel',
                        'outer-class': ['minimal'],
                    },
                ],
            };
            schema.push(buttonDiv);
            return schema;
        },
        startTransition(transObj) {
            console.log('HELLO FROM startTransition');
            if (!this.canStartTrigger) return;  // if we can't trigger right now, just return 
            this.activeTransition = Object.assign({}, transObj);
            // called when user selects a transition -- may need to show modal to collect data
            // this just figures out what is next and calls that
            const hasCollectData = !!transObj.collect_data && Array.isArray(transObj.collect_data) && transObj.collect_data.length;
            if (hasCollectData) {
                console.log('we DO have collectData');
                // if we have to collect data, show the modal and gather it - otherwise proceed with calling it
                const formSchema = this.buildFormSchema(transObj);
                this.collectDataValues = {};  // reset the values -- or get 'defaults' or 'initial' from backend?
                this.collectDataSchema = formSchema;
                this.collectDataModal = true;  // show the modal
            } else {
                // no data to collect?  just trigger the transition directly
                // call it async/await?  not here...
                this.callTransition(transObj, null);
            }
        },
        handleCollectDataSubmit(submitData) {
            console.log('HELLO FROM handleCollectDataSubmit');
            console.log(submitData);  // submitData should be values from collectData
            // call it async/await?  not here...
            this.callTransition(this.activeTransition, submitData);
        },
        handleCollectDataCancel() {
            console.log('HELLO FROM handleCollectDataCancel');
            this.collectDataModal = false;  // close the modal
        },
        async callTransition(transObj, collectData) {
            console.log('HELLO FROM callTransition');
            // pass in 2 args -- 1) full transition object and 2) any collectData we gathered, if required
            // do we need to prep collectData for sending??? set defaults?  change types???
            // need to put things into one object as backend is expecting
            const finalCollectData = collectData ? { ...collectData } : {};
            const triggerData = {
                trigger: transObj.trigger,
                ...finalCollectData,
            };
            this.loading = true;
            try {
                const resp = await suppliosApi.rfxResponse.call_transition(this.responseId, triggerData);
                // successful?  emit something to parent to refresh?
                this.handleStateChange(resp.data);  // should be object with keys { success (bool), rfx_response (RfxResponse object, maybe with sparse fields)}
            } catch (err) {
                // TODO - check response code - if 403, try reloading available transitions?  but that was done in the parent... uggh
                console.log('got an error - below');
                console.log(err);
                console.log(typeof err);
                console.log(err.toJSON());  // works! - but not highlighted as error when doing console.log() - maybe do console.error() instead - actually, your error handler already does that, so no need to duplicate
                // err.response is where all the good stuff is:  { config, data, headers, request, status, statusText }
                if (err.response?.status === 403) {  // if we got 403, either we have someone trying to do bad things, or the state just got updated and that transition is no longer available
                    this.$toast('That action is no longer available.  Try refreshing the page, then try again.');
                } else {
                    this.apiErrorHandler(err, 'Error while processing this.  Please contact Supplios support.');
                }
            }
            this.collectDataModal = false;
            this.loading = false;
        },
        handleStateChange(apiResp) {
            console.log('HELLO FROM handleStateChange');
            // pass something up to parent, such as new state if we get that back from api after transition?
            // we'll pass up whatever we got back from api -- should be this:
            // { success (bool), rfx_response (RfxResponse object, maybe with sparse fields)}
            this.$emit('state-change', apiResp);
            // and also refresh the state?  maybe a prop should tell us what to do...
            this.getTransitions();
        },
        onModalHidden() {
            // reset things on modal hidden -- wait until totally hidden
            this.resetActiveTransition();
        }
    }
}
</script>

<style>

</style>